import { useContext, useEffect, useState } from 'react';
import { Box, FormControlLabel, Switch } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { isDocEditable, sectionSelectors, selectDocument } from '../documentSlice';
import { impossible } from '../../../app/Utils';
import { updateDocSection } from '../documentsApi';
import { APIError } from '../../../app/appTypes';
import { Localized } from '@fluent/react';
import { showError } from '../../notifications/notificationsSlice';
import { SectionDeleteContext } from '../DocumentContent';
import { Attachements } from '../../urs/Attachements';
import { DocumentSectionDeleteDialog } from '../utils/DeleteSectionDialog';
import { DocumentSectionHeader } from '../components/DocumentSectionHeader';
import { PrintPreviewDocumentTestTeam } from './PrintPreviewDocumentTestTeam';
import { DocumentTestTeam, loadDocumentTestTeam } from './documentTestTeamApi';
import { unwrapResult } from '@reduxjs/toolkit';
import { ErrorContainer } from '../../../app/ErrorContainer';
import { LoadingContainer } from '../../../app/LoadingContainer';

export const DocumentTestTeamWrapper = (props: { sectionId: string }) => {
    const { sectionId } = props
    const dispatch = useAppDispatch()
    const deleteSection = useContext(SectionDeleteContext)
    const section = useAppSelector(state => sectionSelectors.selectById(state, sectionId)) ?? impossible()
    const { header } = useAppSelector(selectDocument)?.doc ?? impossible()
    const { numeration } = section
    const [error, setError] = useState<APIError | null>(null)
    const [del, setDel] = useState(false)
    const [deleting, setDeleting] = useState(false)
    const isEditable = useAppSelector(isDocEditable)
    const [isPreview, setIsPreview] = useState(false);
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isError, setIsError] = useState<boolean>(false)
    const [documentTestTeam, setDocumentTestTeam] = useState<DocumentTestTeam[]>([]);

    useEffect(() => {
        setIsLoading(true)
        dispatch(loadDocumentTestTeam({ documentId: header.id }))
            .then(unwrapResult)
            .then((team: DocumentTestTeam[]) => {
                setDocumentTestTeam(team);
            })
            .catch((error) => { console.error(error); setIsError(true); setError(error); })
            .finally(() => setIsLoading(false))
    }, [])


    const handleApprove = async (newName: string) => {
        if (newName) {
            try {
                await dispatch(updateDocSection({ ...section, name: newName })).unwrap()
            } catch (error) {
                setError(error as APIError)
            }
        }
    };

    const handleDeleteClick = () => setDel(true)

    const handleConfirmDeleteClick = async () => {
        try {
            setDeleting(true)
            deleteSection(sectionId)
        } catch (error) {
            dispatch(showError('error'))
        } finally {
            setDeleting(false)
        }
    }
    const handleCancelDelClick = () => setDel(false)

    if (isError) {
        return <>
            <ErrorContainer error={error} />
        </>
    }

    if (isLoading) {
        return <>
            <LoadingContainer />
        </>
    }

    return (
        <>
            <DocumentSectionHeader
                numeration={numeration}
                name={section.name}
                isEditable={isEditable}
                error={error}
                onSaveName={handleApprove}
                onDeleteClick={handleDeleteClick}
            />
            <PrintPreviewDocumentTestTeam
                team={documentTestTeam} 
                lang={header.language}
            />
            {del &&
                <DocumentSectionDeleteDialog
                    deleting={deleting}
                    hasSubSections={section.subSectionsIds.length > 0}
                    onConfirm={handleConfirmDeleteClick}
                    onCancel={handleCancelDelClick}
                />
            }

        </>
    );
}
